<template>

  <ButtonsToggle
      v-model="attrs.TRANSPORT_TYPE"
      option-value="CODE"
      option-label="NAME"
      option-badge="BADGE"
      option-badge-color="BADGE_COLOR"
      :props="{
              class: 'q-px-md q-py-none col-grow',
              size: '15px',
              unelevated: true,
              dense: true
            }"
      :props-active="{
              color: 'secondary'
            }"
      :props-inactive="{
              outline: false,
              color: 'grey-2',
              textColor: 'black'
            }"
      :options="transportTypesComputed"
      class="c-buttons flex q-gutter-x-md justify-center no-wrap"
      :show-badge="attrs.TRANSPORT_TYPE !== 'pickup'"
  />
</template>

<script setup lang="ts">
import {storeToRefs} from "pinia";
import ButtonsToggle from "@/components/Ui/ButtonsToggle.vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {computed} from "vue";
import {useBasketRulesStore} from "@/modules/shop/store/basket-rules";


const vorderState = useVorderState()

const basketRulesStore = useBasketRulesStore()

const {
  attrs,
  transportTypes,
} = storeToRefs(vorderState)

const {
  pickupDiscount
} = storeToRefs(basketRulesStore)


const props = withDefaults(defineProps<{
  dense?: boolean
}>(), {
  dense: false,
});

const transportTypesComputed = computed(() => {

  return transportTypes.value.map(transportType => {
    const res: any = {
      ...transportType,
    }
    if (pickupDiscount.value && transportType.CODE === 'pickup') {
      res.BADGE = '-' + String(pickupDiscount.value?.DISCOUNT_PERCENT) + '%'
      res.BADGE_COLOR = 'red'
    }
    return res
  })
})


</script>

<style scoped lang="scss">

.c-buttons {
  :deep(.q-badge) {
    top: -7px;
    right: 0;
    position: absolute;
    margin-left: 10px;
  }
}
</style>
